import { render, staticRenderFns } from "./GestioneRicerca.vue?vue&type=template&id=72354bb8&scoped=true&"
import script from "./GestioneRicerca.vue?vue&type=script&lang=js&"
export * from "./GestioneRicerca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72354bb8",
  null
  
)

export default component.exports